<template>
  <mw-dialog ref="dialog" size="form" :title="title" :appendToBody="false" :footerButton="footerButton"  customClass="mw-flow-complete"  :beforeClose="beforeClose">
    <div class="__form_content">
      <template v-if="fCount> 1">
      <el-row  class="__comment_top __col-h100">
       <el-col class="__col-h100">
      <div class="__left-box" style="margin-right: 0px;">
          <template v-for="flow in workFlows">
          <el-row :ref="'row'+flow.id" :style="rowStyle">
            <el-col :span="12" class="__col-h100">
              <div class="__panel __tree-panel">
                <div class="__panel-heading"><span v-html="$lang(flow.name)"></span><span class="pull-right" style="padding-right:5px;">({{$lang("双击移入")}}>>)</span></div>
                <div class="__panel-body">
                  <mw-li-tree :autoLoad="true" :async="false" :multiple="false"
                                       :ref="'candidate'+flow.id" :treeData="candidates[flow.id]"  @dblClick="dblClick"></mw-li-tree>
                </div>
              </div>
            </el-col>
            <el-col :span="12" class="__col-h100" style="padding-left:5px;">
              <div class="__panel __tree-panel">
                <div class="__panel-heading">{{$lang("已选")}}<span class="pull-right" style="padding-right:5px;">({{$lang("双击移出")}})</span></div>
                <div class="__panel-body">
                  <mw-li-tree :autoLoad="true" :async="false" :multiple="false"
                                                     :ref="'planned'+flow.id" :treeData="planneds[flow.id]" @dblClick="dblClickSelected"></mw-li-tree>
                </div>
              </div>
            </el-col>
          </el-row>
           </template>
        </div>
         </el-col>
         </el-row>
        <el-row class="__comment">
        <el-col  class="__col-h100" >
          <div class="__field-set" style="margin-right: 0px;">
            <div class="__title">{{$lang("意见")}}：<el-button type="default" size="mini" @click="plannedComment()">{{$lang("生成拟办意见")}}</el-button></div>
            <el-input
              type="textarea" resize="none" v-model="comment" class="__col-h100" style="margin-top:2px;">
            </el-input>
          </div>
        </el-col>
      </el-row>
        </template>
        <template v-if="fCount< 1">
           <div class="__sel"> <span class="__btn">{{$lang("未获取到符合条件的流向信息")}}</span></div>
        </template>
    </div>
  </mw-dialog>
</template>
<script>
import MwLiTree from "./tree/li.vue";

export default {
  components: {
    MwLiTree
  },
  props: {
    params: {
      type: Object
    }
  },
  data() {
    let me=this, commentId = $uuid();
    return {
      title:$lang('拟办'),
      rowStyle:'height:225px; padding-bottom:5px;',
      fCount:0,
      workFlows:[],
      candidates:{},
      planneds:{},
      comment:'',
      commentId:commentId,
      commentCategory:'',

      footerButton: [
        {
          label: $lang("关闭"),
          type: "default",
          func:me.close
        },
        {
          label: $lang("确定"),
          func:me.submit
        }
      ]
    }
  },
  mounted() {
    setTimeout(()=>{
      this.show();
    },200)
    this.init();
  },
  watch: {
    params(){
      this.init();
    }
  },
  methods: {
    setBtnLoading(loading,idx){
        this.footerButton[idx].loading=loading;
    },
  btnDebounce:_.debounce(function(callback){
      let me=this;
      if(callback){
      callback();
      }
      }, 1000, {
      'leading': true,
      'trailing': false
    }),
    init(){
      var me = this;
      me.mwApi.process.getPlannedFlows({taskId:me.params.taskId}).then((data)=>{
         let res=data.result;
         if(typeof res.success !='undefined' && !res.success){
            me.fCount = 0;
            return;
         }
         me.workFlows = res;
         me.fCount = res.length;
         me.rowStyle='height:'+Math.floor(100/me.fCount)+'%; padding-bottom:5px;';
         res.map((wf)=>{
           var fcandidates=[];
           var fplanneds=[];
           let cidx=0;
           if(wf.candidates){ //可选
             wf.candidates.map((v)=>{
                if(!v.hidden){
                   var node = Object.assign({},v);
                   node.text = v.name;
                   node.flowId = wf.id;
                   node.idx = cidx++;
                   fcandidates.push(node);
                }
             });
           }
           if(wf.planneds){ //已选
             wf.planneds.map((v)=>{
               var node = me._subPlannedAsNode(v);
               node.flowId = wf.id;
               fplanneds.push(node);
             });
           }
           me.candidates[wf.id]=fcandidates;
           me.planneds[wf.id]=fplanneds;
         });
      });
      me.renderComment();

    },
    renderComment(){
      var me = this;
      if(me.params.comment && me.params.comment.length>0){
        me.comment=me.params.comment[0].content;
        me.commentId=me.params.comment[0].id;
        me.commentCategory=me.params.comment[0].category;
      }else{
        me.commentId=$uuid();
        me.comment='';
        me.commentCategory=me.params.activity.commentCategory;
      }
      /*var moreCommentSwitch = me.params.activity.moreCommentSwitch; //允许添加多条意见
      if(moreCommentSwitch=='0'){ //单条意见则默认读取一条已填写意见
        me.mwApi.business.listComment({taskId:me.params.taskId}).then((data) => {
            var taskComments=data.result;
            if(taskComments.length>0){
                me.comment = taskComments[0].content;
                me.commentId = taskComments[0].id;
            }
        });
      }*/
    },
   dblClick(data){ //移入已选
      if(!data){
         return;
      }
      var me = this;
      var flowId = data.flowId;
      //移出可选框
      var fcandidate = me.candidates[flowId];
      var idx;
      fcandidate.map((v, d)=>{
          if(v.id==data.id){
             idx=d;
             return;
          }
      });
      me.candidates[flowId].splice(idx, 1);
      //移入已选框
      var node = Object.assign({},data);
      node.text = data.name;
      node.flowId = flowId;
      me.planneds[flowId].push(node);
      me.mwRef('planned'+flowId)[0].refreshData(me.planneds[flowId]);
   },
   dblClickSelected(data){ //移入到可选
      if(!data){
         return;
      }
      var me = this;
      var flowId = data.flowId;
      //移出已选框
      var fplanned = me.planneds[flowId];
      let idx;
      fplanned.map((v, d)=>{
          if(v.id==data.id){
             idx=d;
             return;
          }
      });
      me.planneds[flowId].splice(idx, 1);

      //移入可选框
      var node = Object.assign({},data);
      node.text = data.name;
      node.flowId = flowId;
      var cidx = node.idx;
      if(cidx || cidx==0){
         me.candidates[flowId].splice(cidx, 0, node);
      }else{
         me.candidates[flowId].push(node);
      }
      me.mwRef('candidate'+flowId)[0].refreshData(me.candidates[flowId]);
   },
   submit(){ //保存已选
      var me = this;
      me.btnDebounce(function(){
          me.setBtnLoading(true,1);
          let activities=[];
          me.workFlows.map((v)=>{
          var activity={};
          activity.flowId=v.id;
          activity.activityId=v.activityId;
          activity.type = v.type;
          activity.options=v.options;

          var items=[];
          me.planneds[v.id].map((plan)=>{
          items.push(me._nodeAsItem(plan));
          });
          activity.items=items;
          activities.push(activity);
          });
          var params={};
          params.taskId = me.params.taskId;
          params.appId = me.params.appId;
          params.formId = me.params.formId;
          params.activities=activities;
          if(me.comment){
          params.$comment = [{id:me.commentId, content:me.comment, category:me.commentCategory}];
          }
          if(me.params.fullAuthType){
            params.fullAuthType = me.params.fullAuthType;
          }
          me.mwApi.process.planned(params).then((res)=>{
          me.close();
          me.formActionComplete(params);
          me.setBtnLoading(false,1);
          }).catch(()=>{
          me.setBtnLoading(false,1);
          });
      });
   },
   plannedComment(){ //生成拟办意见
      var me = this;
      var dcomment=[];
      var ucomment=[];
      var commentContent='';
      me.workFlows.map((v)=>{
         me.planneds[v.id].map((plan)=>{
             if(v.options.sendUnit =='DEP'){
                dcomment.push(plan.name);
             }else{
                ucomment.push(plan.name);
             }
         });
      });
      if(ucomment.length>0){
         commentContent+= '呈'+ucomment.join(',')+'阅示.';
      }
      if(dcomment.length> 0){
         commentContent += '请'+dcomment.join(',')+'阅知.';
      }
      me.comment = commentContent;
   },
   beforeClose(done){
      var me = this;
      me.mwConfirm($lang('确定退出拟办窗口？')).then(_=>{
        if(me.params.secondfunc){
          me.params.secondfunc();
        }
        me.resetForm();
        done();
      }).catch(_=>{});
    },
    formActionComplete(params){
      var me = this;
      if(me.params.func){
        me.params.func(params);
      }
      this.resetForm();
    },
    close(){
      this.resetForm();
      this.mwRef('dialog').hide();
    },
    show(){
      this.mwRef('dialog').show();
    },
    resetForm(){
      var me = this;
      me.workFlows = [];
      me.candidates = {};
      me.planneds = {};
      me.fCount=0;
      me.rowStyle='height:225px; padding-bottom:5px;';
    },
     _nodeAsItem(n){
       var item = {};
       if(n.type=='U'){
           item.group=n.departmentId;
           if(!item.users){
              item.users=[];
           }
           item.users.push({id:n.id});
       }else if(n.identities){
           item.group=n.id;
           n.identities.map(i=>{
              if(i.type=='U'){
                 if(!item.users){
                     item.users=[];
                 }
                 item.users.push({id:i.id});
              }else{
                 if(!item.identities){
                    item.identities=[];
                 }
                 item.identities.push({id:i.id});
              }
           });
       }
       return item;
     },
     _subPlannedAsNode(v){
       var node = {};
       node.id=v.masterObjectId;
       node.name=v.masterObjectName;
       if(v.masterObjectType=='USER'){
         node.type = 'U';
         node.departmentId = v.masterObjectDeptId;
       }else{
         node.type='D';
       }
       if(v.identities){
         node.identities = v.identities;
       }
       node.text = v.masterObjectName;
       return node;
     }
  }
}
</script>





// WEBPACK FOOTER //
// src/common/components/public-dialog/planned.vue